"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
  __name: 'ImageCanvas',
  props: {
    src: null,
    width: {
      default: 'auto'
    },
    height: {
      default: 'auto'
    },
    objectFit: {
      default: 'fill'
    },
    isPositionStart: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const canvasRef = (0, vue_3.ref)(null);
    const parentRef = (0, vue_3.ref)(null);
    const canvasWidth = (0, vue_3.ref)(0);
    const canvasHeight = (0, vue_3.ref)(0);
    const lastRenderedWidth = (0, vue_3.ref)(0);
    const lastRenderedHeight = (0, vue_3.ref)(0);
    // 计算最终宽度和高度
    const finalWidth = (0, vue_3.computed)(() => props.width === 'auto' ? canvasWidth.value : props.width);
    const finalHeight = (0, vue_3.computed)(() => props.height === 'auto' ? canvasHeight.value : props.height);
    // 更新canvas尺寸
    const updateCanvasSize = () => {
      if (parentRef.value) {
        if (props.width === 'auto') {
          const newWidth = parentRef.value.clientWidth;
          if (newWidth !== canvasWidth.value) {
            canvasWidth.value = newWidth;
          }
        }
        if (props.height === 'auto') {
          const newHeight = parentRef.value.clientHeight;
          if (newHeight !== canvasHeight.value) {
            canvasHeight.value = newHeight;
          }
        }
      }
    };
    // 渲染图像
    const renderImage = () => {
      if (typeof window === 'undefined') return;
      const canvas = canvasRef.value;
      if (!canvas) return;
      // 避免空值和重复渲染
      if (finalWidth.value === 0 || finalHeight.value === 0) return;
      if (finalWidth.value === lastRenderedWidth.value && finalHeight.value === lastRenderedHeight.value) return;
      const dpr = window.devicePixelRatio || 1;
      canvas.width = finalWidth.value * dpr;
      canvas.height = finalHeight.value * dpr;
      canvas.style.width = `${finalWidth.value}px`;
      canvas.style.height = `${finalHeight.value}px`;
      // 使用离屏 canvas 避免闪烁
      const offscreenCanvas = document.createElement('canvas');
      offscreenCanvas.width = canvas.width;
      offscreenCanvas.height = canvas.height;
      const ctx = offscreenCanvas.getContext('2d');
      if (!ctx) return;
      ctx.scale(dpr, dpr);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = props.src;
      img.onload = () => {
        ctx.clearRect(0, 0, finalWidth.value, finalHeight.value);
        let drawWidth = finalWidth.value;
        let drawHeight = finalHeight.value;
        let offsetX = 0;
        let offsetY = 0;
        const imgAspect = img.width / img.height;
        const canvasAspect = finalWidth.value / finalHeight.value;
        if (props.objectFit === 'contain') {
          if (imgAspect > canvasAspect) {
            // 图片更宽，按宽度缩放
            drawWidth = finalWidth.value;
            drawHeight = finalWidth.value / imgAspect;
            if (!props.isPositionStart) {
              offsetY = (finalHeight.value - drawHeight) / 2;
            }
          } else {
            // 图片更高，按高度缩放
            drawHeight = finalHeight.value;
            drawWidth = finalHeight.value * imgAspect;
            if (!props.isPositionStart) {
              offsetX = (finalWidth.value - drawWidth) / 2;
            }
          }
        } else if (props.objectFit === 'cover') {
          if (imgAspect > canvasAspect) {
            // 图片更宽，按高度放大并裁剪
            drawHeight = finalHeight.value;
            drawWidth = finalHeight.value * imgAspect;
            if (!props.isPositionStart) {
              offsetX = (finalWidth.value - drawWidth) / 2;
            }
          } else {
            // 图片更高，按宽度放大并裁剪
            drawWidth = finalWidth.value;
            drawHeight = finalWidth.value / imgAspect;
            if (!props.isPositionStart) {
              offsetY = (finalHeight.value - drawHeight) / 2;
            }
          }
        }
        ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
        const mainCtx = canvas.getContext('2d');
        if (mainCtx) {
          mainCtx.clearRect(0, 0, finalWidth.value, finalHeight.value);
          mainCtx.drawImage(offscreenCanvas, 0, 0);
        }
        lastRenderedWidth.value = finalWidth.value;
        lastRenderedHeight.value = finalHeight.value;
      };
      img.onerror = err => console.error('图片加载失败:', err);
    };
    let resizeObserver = null;
    (0, vue_3.onMounted)(() => {
      if (typeof window === 'undefined') return;
      updateCanvasSize(); // 组件挂载时计算尺寸
      // 确保在DOM更新后再尝试渲染
      (0, vue_3.nextTick)(() => {
        renderImage();
      });
      // 设置ResizeObserver监听父元素大小变化
      resizeObserver = new ResizeObserver(() => {
        setTimeout(updateCanvasSize, 100); // 增加 debounce 防止频繁触发
      });

      if (parentRef.value) resizeObserver.observe(parentRef.value);
    });
    (0, vue_3.onUnmounted)(() => {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    });
    // 统一监听所有依赖项变化
    (0, vue_3.watch)([() => props.src, () => props.width, () => props.height, () => props.objectFit, finalWidth, finalHeight], () => {
      // 确保在DOM更新后渲染
      (0, vue_3.nextTick)(renderImage);
    }, {
      immediate: false
    });
    return (_ctx, _cache) => {
      return (0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
        ref_key: "parentRef",
        ref: parentRef,
        style: (0, vue_2.normalizeStyle)({
          width: props.width === 'auto' ? '100%' : props.width + 'px',
          height: props.height === 'auto' ? '100%' : props.height + 'px'
        })
      }, [(0, vue_2.createElementVNode)("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        style: {
          "background": "transparent"
        }
      }, null, 512)], 4);
    };
  }
});